module.exports = __webpack_public_path__ + "img/xxjsfwgltxrzzs.847e5478.png";